import { Dashboard } from '@99designs/dashboard';
import { useIdentityContext } from '@99designs/design-services-common';
import { AuthenticatedApolloProvider } from '@99designs/graph-utils';
import { TRACKING_CALLER } from '../lib/consts';

export type ContentProps = {
    locale: string;
    environment?: string;
};

export const Content = ({ locale, environment }: ContentProps) => {
    const { isSignedIn, auth } = useIdentityContext();

    if (!auth) {
        return null;
    }

    if (!isSignedIn) {
        auth?.signIn([], [], { navHint: '', trackingCaller: TRACKING_CALLER });
        return;
    }

    return (
        <AuthenticatedApolloProvider
            locale={locale}
            environment={environment === 'DEV' ? 'non-production' : 'production'}
            endpoint={
                environment === 'DEV'
                    ? 'http://graph.dockervm:49944/graph'
                    : 'https://graph.es.vpsvc.com/graph'
            }
        >
            <Dashboard />
        </AuthenticatedApolloProvider>
    );
};
